const styles = theme => ({
  organizationSizeTitle: {
    marginBottom: theme.spacing(8),
    color: theme.palette.primary.default
  },
  groupCodeContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    height: "60px"
  },
  organizationExplanation: {
    marginTop: theme.spacing(2),
    color: theme.palette.primary.default
  },
  labelTextColor: {
    color: theme.palette.primary.default
  },
  inputReusableFormControl: {
    marginBottom: "30px"
  },
  sliderDesktop: {
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  },
  sliderPhone: {
    [theme.breakpoints.up("lg")]: {
      display: "none"
    }
  },
  activeSlider: {
    color: theme.palette.primary.default,
    fontWeight: 700
  },
  markLabel: {
    marginLeft: "25px"
  },
  rail: {
    width: "10px!important"
  },
  mark: {
    width: "10px!important"
  },
  thumb: {
    marginLeft: "-7px!important"
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/steps/Step3OrganizationSize/styles.js